import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-469d706f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "controls"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "scanner" }
const _hoisted_6 = { id: "video" }
const _hoisted_7 = {
  key: 0,
  class: "select_wrapper"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, "Wähle deine Kamera aus", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 2,
  class: "fallback"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dein Browser unterstützt keinen QR-Code-Reader. Gebe den Code manuell ein", -1))
const _hoisted_12 = ["disabled"]

import { ref, computed } from "vue";
import { Device } from "@/types";
import { Html5Qrcode } from 'html5-qrcode';


export default /*#__PURE__*/_defineComponent({
  emits: ["idDetected", "noIdDetected"],
  setup(__props, { emit }: { emit: ({
  (e: 'idDetected', id: string): void
  (e: 'noIdDetected'): void
}), expose: any, slots: any, attrs: any }) {



let scanner = ref<any | boolean>(false)
let scannerActive = ref<boolean>(false)
let allDevices = ref<Array<Device> | boolean>(false)
let deviceSelected = ref<string | any>('')
let deviceSaved = ref<string>('')
let notSupported = ref<boolean>(false)
let manualId = ref<string>('')
let manualIdValid = computed<boolean>(() => {
  return manualId.value.toString().length === 6
})

let initScanner = () => {
  loadSavedDevice()
  Html5Qrcode.getCameras()
      .then(devices => {
        allDevices.value = devices;
        if(deviceSaved.value && devices.find(device => {
          return device.id === deviceSaved.value
        })){
          presetScanner()
        }
      })
      .catch(error => {
        if(error.name === 'NotAllowedError'){
          notSupported.value = true
        }
      })
}
let presetScanner = () => {
  deviceSelected.value = deviceSaved.value
  scann(deviceSelected.value)
}
let loadSavedDevice = () => {
  deviceSaved.value = localStorage.getItem('preferedDevice') !== null ? localStorage.getItem('preferedDevice') || '' : ''
}
let scann = (deviceId: string) => {
  localStorage.setItem('preferedDevice', deviceId)
  scannerActive.value = true
  scanner.value = new Html5Qrcode('video');
  scanner.value.start(
      deviceSelected.value,
      {
        fps: 10,
        aspectRatio: 1
      },
      (decodedText: string) => {
        if (decodedText) {
          const result = decodedText.startsWith(']C1') ? decodedText.slice(3) : decodedText;
          sendResult(result)
          stopScanner()
        } else {
          noResult()
          stopScanner()
        }
      });
}
let stopScanner = () => {
  scanner.value.stop()
  scanner.value = false
  scannerActive.value = false
  allDevices.value = false
  deviceSelected.value = ''
  notSupported.value = false
}
let sendResult = (result: string|number) => {
  emit('idDetected', result.toString())
  manualId.value = ''
}
let noResult = () => {
  emit('noIdDetected')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(notSupported))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Scanne hier deinen QR-Code"))
      : _createCommentVNode("", true),
    (!_unref(notSupported))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "light-bg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(initScanner) && _unref(initScanner)(...args))),
            disabled: _unref(scannerActive)
          }, "start", 8, _hoisted_3),
          _createElementVNode("button", {
            class: "light-bg",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(stopScanner) && _unref(stopScanner)(...args))),
            disabled: !_unref(scannerActive)
          }, "stop", 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
        [_vShow, _unref(scannerActive)]
      ]),
      (_unref(allDevices) && !_unref(notSupported))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(deviceSelected) ? (deviceSelected).value = $event : deviceSelected = $event)),
              id: "cars",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(scann)(_unref(deviceSelected))))
            }, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allDevices), (device) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: device.id,
                  value: device.id
                }, _toDisplayString(device.label), 9, _hoisted_9))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(deviceSelected)]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(notSupported))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            class: "text-center",
            type: "number",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(manualId) ? (manualId).value = $event : manualId = $event))
          }, null, 512), [
            [_vModelText, _unref(manualId)]
          ]),
          _createElementVNode("button", {
            disabled: !_unref(manualIdValid),
            class: "light-bg",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(sendResult)(_unref(manualId))))
          }, "Zur Sammlung hinzufügen", 8, _hoisted_12)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})